import React from 'react';
import { Form } from 'react-bootstrap';
import MultiSearchDropdown from '../../atoms/multiSearchDropdown/view';
import './style.css';

const documentTypes = [
  { id: 'FV', name: 'Factura de Venta' },
  { id: 'RC', name: 'Recibo de Caja' },
  { id: 'CE', name: 'Comprobante de Egreso' },
  { id: 'NC', name: 'Nota Crédito' },
  { id: 'ND', name: 'Nota Débito' },
  { id: 'DS', name: 'Documento Soporte' },
  { id: 'CC', name: 'Causación de Compra' },
  { id: 'NT', name: 'Nota de Traslado' },
];

const DocumentTypeMultiselect = ({ selectedTypes, onSelected }) => {
  // Convert current selection IDs to full objects for MultiSearchDropdown
  const selectedObjects = documentTypes.filter(dt => selectedTypes.includes(dt.id));

  const handleSelected = (newSelected) => {
    onSelected(newSelected.map(ns => ns.id));
  };

  return (
    <div className="document-type-multiselect-standard">
      <Form.Label className="text-secondary small fw-bold text-uppercase mb-2">Tipos de Comprobante</Form.Label>
      <MultiSearchDropdown
        placeholder="Elegir tipos (FV, RC...)"
        options={documentTypes}
        path="name"
        onSelected={handleSelected}
        selected={selectedObjects}
      />
    </div>
  );
};

export default DocumentTypeMultiselect;
